import styled from 'styled-components';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';
import { Box } from 'src/viewLayer/components/DesignSystem';

import devices from 'src/viewLayer/styling/mixins/media-queries';

export const Container = styled(Box)`
  background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.neutral.onSurfaceDefault};
  border-radius: ${tokens.size.radius.small};

  @media ${devices.fromsmall} {
    width: 20.5rem;
  }
`;
